import { HttpHeaders } from "@angular/common/http";
import { inject, Service } from "@angular/core";

import { AdaaHelper } from "../../core/utils";
import {
  type EmployeePulseDashboardModel,
  type EmployeePulseFilters,
  type EmployeePulseLookups,
  MainResponseModel,
} from "../models";
import { MainService } from "./main-service";

@Service()
export class EmployeePulseApiService {
  private readonly _mainService = inject(MainService);

  public upload(quarter: string, file: File) {
    const [, quarterName] = quarter.split("-");
    const data = new FormData();

    data.append("file", file);
    data.append("quarter", quarter);

    return this._mainService.sendRequest<MainResponseModel<null>>({
      method: "POST",
      url: `employee-pulse/upload?Quarter=${quarterName}`,
      data,
      headers: new HttpHeaders(),
    });
  }

  public publish(id: number) {
    return this._mainService.sendRequest<MainResponseModel<null>>({
      method: "POST",
      url: `employee-pulse/logs/${id}/publish`,
      data: {},
    });
  }

  public download(year: string, quarter: string) {
    return this._mainService.sendRequest<Blob>({
      method: "GET",
      url: `employee-pulse/download?year=${year}&quarter=${quarter}`,
      responseType: "blob",
    });
  }

  public getDashboardData(year: number, quarter: number, preview: boolean, filters: EmployeePulseFilters = {}) {
    const { entityFilters, ...demographics } = filters;
    const query = `year=${year}&quarter=${quarter}&preview=${preview}`;

    if (AdaaHelper.isPMOEntity()) return this._getDashboardData(query, filters);
    return this._getDashboardData(`entityId=${entityFilters}&${query}`, demographics);
  }

  public getLookups() {
    return this._mainService.sendRequest<MainResponseModel<EmployeePulseLookups>>({
      method: "GET",
      url: "employee-pulse/lkup",
    });
  }

  private _getDashboardData(query: string, data: EmployeePulseFilters) {
    return this._mainService.sendRequest<MainResponseModel<EmployeePulseDashboardModel>>({
      method: "POST",
      url: `employee-pulse/data?${query}`,
      data,
    });
  }
}
